import React, { useEffect } from "react";

const Testimonial = ({ theme }) => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://static.elfsight.com/platform/platform.js";
    script.async = true;
    document.body.appendChild(script);

    const observer = new MutationObserver(() => {
      const badge = document.querySelector('a[href*="elfsight.com/google-reviews-widget"]');
      if (badge && badge.style.display !== "none") {
        badge.style.display = "none";
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      document.body.removeChild(script);
      observer.disconnect();
    };
  }, []);

  const isDark = theme === "dark";

  return (
    <>
      <style>{`
        /* Hide Elfsight Logo/Branding Badge globally */
        a[href*="elfsight"],
        div[class*="BadgeComponent"],
        a[class*="Badge"],
        div[class*="Badge"],
        a[class*="elfsight-app"] {
          display: none !important;
          opacity: 0 !important;
          visibility: hidden !important;
          height: 0 !important;
          padding: 0 !important;
        }
      `}</style>
      {isDark && (
        <style>{`
          .dark-theme-testimonials div[class*="Header__Container"] span,
          .dark-theme-testimonials div[class*="Header__Container"] div,
          .dark-theme-testimonials div[class*="HeaderComponent"] span,
          .dark-theme-testimonials div[class*="HeaderComponent"] div {
            color: #ffffff !important;
          }
          .dark-theme-testimonials div[class*="WidgetContainer"] {
            background: transparent !important;
          }
          .dark-theme-testimonials div[class*="Header__Container"],
          .dark-theme-testimonials div[class*="HeaderComponent"] {
            background: rgba(255, 255, 255, 0.02) !important;
            border: 1px solid rgba(255, 255, 255, 0.06) !important;
            border-radius: 16px !important;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4) !important;
          }
          .dark-theme-testimonials div[class*="Card__Container"],
          .dark-theme-testimonials div[class*="ReviewCard__Container"] {
            background: rgba(255, 255, 255, 0.03) !important;
            backdrop-filter: blur(10px) !important;
            border: 1px solid rgba(255, 255, 255, 0.06) !important;
            box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3) !important;
            color: #ffffff !important;
            transition: all 0.3s ease !important;
          paddingBottom: "4rem"
          .dark-theme-testimonials div[class*="Card__Container"]:hover,
          .dark-theme-testimonials div[class*="ReviewCard__Container"]:hover {
            transform: translateY(-4px) !important;
            border-color: rgba(232, 255, 0, 0.3) !important;
            box-shadow: 0 0 15px rgba(232, 255, 0, 0.1), 0 8px 25px rgba(0, 0, 0, 0.5) !important;
          }
        `}</style>
      )}
      <section
        className={`py-4 px-2 px-lg-0 ${isDark ? "dark-theme-testimonials pb-0" : "bg-white"}`}
        style={isDark ? {
          background: "transparent",
          paddingTop: "4rem",
          paddingBottom: "0.5rem"
        } : {}}
      >
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="text-center">
              <h2
                className="fw-semibold"
                style={isDark ? {
                  color: "#ffffff",
                  fontSize: "32px",
                  fontFamily: '"Poppins", sans-serif'
                } : {}}
              >
                {isDark ? (
                  <>Customer <span style={{ color: "#e8ff00" }}>Testimonials</span></>
                ) : (
                  "Customer Testimonials"
                )}
              </h2>
              <p
                className="d-flex justify-content-center mt-15 mb-20"
                style={isDark ? {
                  color: "rgba(255, 255, 255, 0.7)",
                  fontFamily: '"Poppins", sans-serif',
                  maxWidth: "700px",
                  marginLeft: "auto",
                  marginRight: "auto"
                } : {}}
              >
                Here's what our customers are saying about the 9R NFC Card.
                Trusted by professionals and businesses, the 9R NFC Card makes
                digital sharing seamless and stylish.
              </p>
            </div>
            <div
              className="elfsight-app-7c3d86bd-678d-43ed-b8b6-e3167d865d24"
              data-elfsight-app-lazy
            ></div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Testimonial;
